import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  Asset,
  ASSET_STATUS_INFO_COMPLETE, ASSET_STATUS_MISSING_INFO,
  AuditAssetMove,
  MOVE_ASSET_BACK_TO_OPPORTUNITY, MOVE_ASSET_BACK_TO_WIP, MOVE_ASSET_INTO_AUCTION_EVENT,
  MOVE_ASSET_INTO_HOLDING_PEN, MOVE_ASSET_INTO_OTHER_CONTRACT, MOVE_ASSET_INTO_OTHER_OPPORTUNITY, SEND_ASSETS_TO_OPERATIONS
} from '../../../shared/domain/item';
import {pullLotConfirmationType, assetMoveReasons, ASSET_MOVE_REASON_OTHER} from '../../../shared/domain/item/item-move';
import {CustomErrorStateMatcher} from '../../../shared/form';

@Component({
  selector: 'lib-item-summary-move-reason-customer-confirmation',
  templateUrl: './move-reason-customer-confirmation.component.html',
  styleUrls: ['./move-reason-customer-confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MoveReasonCustomerConfirmationComponent implements OnInit {

  @Input() auditAssetMove: AuditAssetMove;
  @Input() assets: Asset[];
  @Input() contractId: number;
  @Output() valid = new EventEmitter();

  @ViewChild('moveReasonForm', {static: true}) moveReasonForm: HTMLFormElement;

  public matcher = new CustomErrorStateMatcher();
  public confirmationTypeOptions = pullLotConfirmationType;
  public assetMoveReasons = assetMoveReasons;
  public ASSET_MOVE_REASON_OTHER = ASSET_MOVE_REASON_OTHER;
  public isPreSaleAssets = false;
  public isMoveReasonRequired = false;
  public isCustomerConfirmationRequired = false;
  public maxConfirmedOnDate = new Date();

  private moveReasonFormSubscription: Subscription;

  constructor() {
  }

  ngOnInit() {
    this.configureData();
    this.subscribeMoveReasonFormChanges();
  }

  public isPullingLots(): boolean {
    return this.auditAssetMove.destinationType ===  MOVE_ASSET_BACK_TO_OPPORTUNITY ||
      this.auditAssetMove.destinationType === MOVE_ASSET_INTO_HOLDING_PEN;
  }

  private isAllAssetsInWIP(): boolean {
    for (let i = 0 ; i < this.assets.length ; i++) {
      if (!(this.assets[i].assetStatusId === ASSET_STATUS_INFO_COMPLETE || this.assets[i].assetStatusId === ASSET_STATUS_MISSING_INFO)) {
        return false;
      }
      return true;
    }
  }

  private configureData(): void {
    switch (this.auditAssetMove.destinationType) {
      case MOVE_ASSET_BACK_TO_WIP:
        this.isMoveReasonRequired = false;
        this.isCustomerConfirmationRequired = false;
        break;
      case MOVE_ASSET_INTO_OTHER_OPPORTUNITY:
        this.isMoveReasonRequired = false;
        this.isCustomerConfirmationRequired = false;
        break;
      case MOVE_ASSET_BACK_TO_OPPORTUNITY:
        this.isMoveReasonRequired = true;
        this.isCustomerConfirmationRequired = false;
        break;
      case MOVE_ASSET_INTO_OTHER_CONTRACT:
        this.isMoveReasonRequired = true;
        this.isCustomerConfirmationRequired = true;
        break;
      case MOVE_ASSET_INTO_AUCTION_EVENT:
        if (!this.isAllAssetsInWIP()) {
          if (this.contractId) {
            this.isMoveReasonRequired = true;
            this.isCustomerConfirmationRequired = true;
          } else {
            this.isMoveReasonRequired = false;
            this.isCustomerConfirmationRequired = false;
          }
        }
        break;
      case MOVE_ASSET_INTO_HOLDING_PEN:
        this.isMoveReasonRequired = true;
        this.isCustomerConfirmationRequired = false;
        break;
      case SEND_ASSETS_TO_OPERATIONS:
        this.isMoveReasonRequired = false;
        this.isCustomerConfirmationRequired = true;
        break;
    }
    this.auditAssetMove.confirmedOn = new Date();
  }

  private subscribeMoveReasonFormChanges() {
    this.moveReasonFormSubscription = this.moveReasonForm.valueChanges.subscribe(
      change => {
        const moveReasonComponent = this;
        setTimeout(() => {
          moveReasonComponent.valid.emit(moveReasonComponent.moveReasonForm.valid);
        });
      }
    );
  }

}
